// extracted by mini-css-extract-plugin
export default {"wave":"CrochetBackground_wave__O8y-X","container":"CrochetBackground_container__2j-g9","gradient":"CrochetBackground_gradient__lJYPk"};